import React, { useState } from "react";
import "./CustomerTable.css";
import CustomerServiceModal from "./CustomerServiceModal/CustomerServicesModal";

const CustomerTable = ({ data, page, limit }) => {
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  
  const handleViewServices = (customer) => {
    console.log("CUSTOMER",customer)
    setSelectedCustomer(customer);
    setIsModalOpen(true);

  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedCustomer(null);
  };
  return (
    <div className="quote-table-wrapper">
      <table className="quote-table">
        <thead>
          <tr>
            <th className="td-sr">Sr.</th>
            <th>Full Name</th>
            <th>Email ID</th>
            <th>Mobile No.</th>
            {/* <th>Date of Birth</th> */}
            <th>State</th>
            <th>City</th>
            <th>Services</th>
          </tr>
        </thead>

        <tbody>
          {data.length === 0 ? (
            <tr>
              <td colSpan="7" className="no-data">
                No Customer found
              </td>
            </tr>
          ) : (
            data.map((item, index) => (
              <tr key={item.id || index}>
                {/* <td>{index + 1}</td> */}
                <td className="td-sr">
                  {(page - 1) * limit + index + 1}
                </td>
                <td>{item.name}</td>
                <td className="email">{item.email}</td>
                <td>{item.mobile}</td>
                {/* <td>{item.dob}</td> */}
                <td>{item.state}</td>
                <td>{item.city}</td>
                <td className="action-col">
                  <button
                    className="chat-btn"
                    onClick={() => handleViewServices(item)}
                    //  onClick={() => console.log("MY CUSTOMER",item)}
                  >
                    View Services
                  </button>
                </td>

              </tr>
            ))
          )}
        </tbody>
      </table>

       {/* {isModalOpen && ( */}
     {/* {isModalOpen && ( */}
  <CustomerServiceModal
    isOpen={isModalOpen}
    customer={selectedCustomer}
    onClose={closeModal}
  />
{/* )} */}
      {/* )} */}
    </div>
  );
};

export default CustomerTable;
